import { render, staticRenderFns } from "./TableList.vue?vue&type=template&id=2b8d2eee&scoped=true&"
import script from "./TableList.vue?vue&type=script&lang=ts&"
export * from "./TableList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b8d2eee",
  null
  
)

export default component.exports